const MUTATION_KEYS = {
  UPDATE_PICTURE: 'update picture',
  DELETE_PICTURE: 'delete picture',
  UPDATE_USER: 'update user',
  CREATE_ORGANIZATION: 'create organization',
  RESEND_ORGANIZATION_ACTIVATION_LINK: 'resend activation link',
  UPDATE_ORGANIZATION: 'update organization',
  UPDATE_WORKPLACE: 'update workplace',
  UPDATE_WORKPLACE_TEMPLATE: 'update workplace template',
  ASSETS_YEAR_PLANNER_CREATE: 'create year planner',
  ASSETS_YEAR_PLANNER_UPDATE: 'update year planner',
  ORGANIZATION_YEAR_PLANNER_TEMPLATE_CREATE: 'create organization year planner template',
  ORGANIZATION_YEAR_PLANNER_TEMPLATE_UPDATE: 'update organization year planner template',
  ORGANIZATION_YEAR_PLANNER_TEMPLATE_DELETE: 'delete organization year planner template',
  PROCESSING_ACTIVITIES_ARCHIVE: 'archive processing activity',
  PROCESSING_ACTIVITIES_DELETE_DRAFT: 'delete processing activity draft',
  ROPA_REVIEWS_CREATE: 'create ropa review',
  ROPA_REVIEWS_UPDATE_DETAILS: 'update ropa review details',
  ROPA_REVIEWS_ACCEPT_PROCESSING_REVIEW: 'accept processing activity review',
  ROPA_REVIEWS_REQUEST_CLARIFICATION: 'request processing activity review clarification',
  ROPA_REVIEWS_BULK_ACCEPT_SUBMITTED: 'bulk accept submitted asset reviews',
  ROPA_REVIEWS_COMPLETE: 'complete ropa review',
  ROPA_REVIEWS_CANCEL: 'cancel ropa review',
  ROPA_REVIEWS_CANCEL_INCOMPLETE_ASSET_REVIEW: 'cancel incomplete asset review',
  ASSET_ROPA_APA_UPDATE: 'update asset processing activity',
  ASSET_ROPA_APA_SUBMIT: 'submit asset processing activity for review',
  ASSET_ROPA_ADD_PROCESSING_ACTIVITY: 'add asset processing activity',
  ASSET_ROPA_SOFT_DELETE_APA: 'soft delete asset processing activity',
  ASSET_ROPA_CONFIRM_NO_PROCESSING_ACTIVITIES: 'confirm no processing activities',
  DPIA_REQUEST_SAVE_DRAFT: 'save dpia need assessment draft',
  DPIA_REQUEST_DECIDE_REQUIRED: 'decide dpia required',
  DPIA_REQUEST_DECIDE_NOT_REQUIRED: 'decide dpia not required',
  DPIA_REQUEST_CANCEL: 'cancel dpia need assessment request',
  DPIA_REQUEST_REASSESS: 'reassess approved dpia',
  DPIA_UPDATE: 'update dpia',
  DPIA_SUBMIT: 'submit dpia for review',
  DPIA_APPROVE: 'approve dpia',
  DPIA_REQUEST_CLARIFICATION: 'request dpia clarification',
  LIA_UPDATE: 'update lia',
  LIA_SOFT_DELETE: 'soft delete lia',
};

export default MUTATION_KEYS;
